'use client';

import { c as _c } from "react/compiler-runtime";
import { Kbd } from '@nordcom/nordstar';
import { Search } from 'lucide-react';

/**
 * Search button in the shell header that opens the CommandPalette by dispatching a synthetic ⌘K keyboard event.
 */
export function CommandPaletteTrigger() {
  const $ = _c(1);
  let t0;
  if ($[0] === Symbol.for("react.memo_cache_sentinel")) {
    t0 = <button type="button" aria-label="Search and navigate" className="flex h-9 items-center gap-2 rounded-md border-2 border-border bg-background px-3 font-medium text-muted-foreground text-sm transition-colors hover:bg-muted" onClick={_temp}><Search className="h-4 w-4" /><span className="hidden md:inline">Search…</span><Kbd className="ml-2 hidden md:inline-flex">⌘K</Kbd></button>;
    $[0] = t0;
  } else {
    t0 = $[0];
  }
  return t0;
}
function _temp() {
  return window.dispatchEvent(new KeyboardEvent("keydown", {
    key: "k",
    metaKey: true
  }));
}